module.exports = __webpack_public_path__ + "static/media/map-illustration.a6e36776.png";